import EventShare from '@/models/EventShare'

export class DeviceEventShareTransformer {
    transform (data) {
        return EventShare(
            data.id,
            data.name,
            data.uri,
            data.expirationDate,
            data.eventId,
            data.dateOfOccurrence,
            data.description,
            data.device
        )
    }
}
